import { render } from "./ListPage.vue?vue&type=template&id=3a8a296f&scoped=true&ts=true"
import script from "./ListPage.vue?vue&type=script&lang=ts"
export * from "./ListPage.vue?vue&type=script&lang=ts"

import "./ListPage.vue?vue&type=style&index=0&id=3a8a296f&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/pontuei/pontuei-painel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a8a296f"]])

export default __exports__